import Vue from 'vue'
import session from '@/shared/session'

// initial state
const initialState = () => ({
	record: null,
})

const state = initialState()

// getters
const getters = {
	getMaternityRecord: (state) => () => {
		return state.record
	},
	getPregnancies: (state) => () => {
		return state.record ? state.record.pregnancies : []
	},
	getVisits: (state) => () => {
		return state.record ? state.record.visits : []
	},
	getUltrasounds: (state) => () => {
		return state.record ? state.record.ultrasounds : []
	},
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async getMaternityRecordForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "maternity", { root: true })

		const record = await session
			.get(`/api/maternity/`, {
				params: { patient: rootState.patients.current?.id },
			})

		// MaternityRecord is one-to-one with a patient
		const data = Array.isArray(record.data) ? record.data[0] || null : record.data
		commit("set_record", data)

		dispatch("loading/end", "maternity", { root: true })

		return state.record
	},

	createMaternityRecord({ commit, dispatch, rootState }, data) {
		dispatch("loading/load", "maternity", { root: true })
		return session
				.post(`/api/maternity/`, {...data, patient: rootState.patients.current?.id})
				.then(() => {
					return dispatch("getMaternityRecordForCurrentPatient")
				})
			.finally(() => {
				dispatch("loading/end", "maternity", { root: true })
			})
	},

	updateMaternityRecord({ commit, dispatch }, data) {
		dispatch("loading/load", "maternity", { root: true })
		return session
				.patch(`/api/maternity/${data.id}/`, data)
				.then(() => {
					return dispatch("getMaternityRecordForCurrentPatient")
				})
			.finally(() => {
				dispatch("loading/end", "maternity", { root: true })
			})
	},

	createPregnancy({ dispatch }, data) {
		return session
				.post(`/api/maternity/pregnancies/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	updatePregnancy({ dispatch }, data) {
		return session
				.put(`/api/maternity/pregnancies/${data.id}/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	deletePregnancy({ dispatch }, id) {
		return session
				.delete(`/api/maternity/pregnancies/${id}/`)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	createVisit({ dispatch }, data) {
		return session
				.post(`/api/maternity/visits/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	updateVisit({ dispatch }, data) {
		return session
				.put(`/api/maternity/visits/${data.id}/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	deleteVisit({ dispatch }, id) {
		return session
				.delete(`/api/maternity/visits/${id}/`)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	createUltrasound({ dispatch }, data) {
		return session
				.post(`/api/maternity/ultrasounds/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	updateUltrasound({ dispatch }, data) {
		return session
				.put(`/api/maternity/ultrasounds/${data.id}/`, data)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	deleteUltrasound({ dispatch }, id) {
		return session
				.delete(`/api/maternity/ultrasounds/${id}/`)
				.then(() => dispatch("getMaternityRecordForCurrentPatient"))
	},

	maternityTotalReport({ commit, state }) {
		return session
				.get(`/api/maternity/total_report/`)
				.then(results => {
					return results.data
				})
	},
}

// mutations
const mutations = {
	reset_state(state) {
		Object.assign(state, initialState())
	},

	set_record(state, value) {
		Vue.set(state, 'record', value)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
